import angular from 'angular';

export const MeurhBureausListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider): void {
        $stateProvider
            .state('meurh_bureaus', {
                url: '/bureaus',
                template: require('html-loader!./index/bureaus.index.html'),
                controller: 'MeurhBureausIndexController',
                controllerAs: 'bureaus_cntrllr',
            });
    }
];
